import React, { lazy } from 'react';
import { SectionHeader, Button, FadeIn } from '../ui';
export function DisplayHome() {
  return <section id="latitude" className="py-16 md:py-24 bg-white border-y border-atrium-stone/30 scroll-mt-24" data-id="element-148">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-149">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-150">
          <div className="w-full lg:w-1/2 order-2 lg:order-1" data-id="element-151">
            <FadeIn data-id="element-152">
              <SectionHeader eyebrow="Now Open" title="Visit Latitude, our Applecross display home" data-id="element-153" />
              <p className="text-base md:text-lg text-atrium-ink/80 leading-relaxed mb-10" data-id="element-154">
                27 Simpson Street, Applecross.
                <br data-id="element-155" />
                Open Wed 2 to 4.30pm, Sat & Sun 1 to 4.30pm, or by private
                appointment.
              </p>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-8" data-id="element-156">
                <Button variant="primary" as="a" href="#enquire" data-id="element-157">
                  Plan Your Visit
                </Button>
                <Button variant="secondary" as="a" href="#enquire" data-id="element-158">
                  Book a Private Appointment
                </Button>
              </div>

              <div className="flex items-center gap-4 mb-12" data-id="element-159">
                <Button variant="tertiary" as="a" href="tel:+61863108888" data-id="element-160">
                  Call Before You Visit
                </Button>
              </div>

              <p className="text-sm font-medium text-atrium-ink/60 italic" data-id="element-161">
                New Dalkeith display home, coming soon.
              </p>
            </FadeIn>
          </div>

          <div className="w-full lg:w-1/2 order-1 lg:order-2" data-id="element-162">
            <FadeIn delay={200} data-id="element-163">
              <div className="relative aspect-[4/3] overflow-hidden" data-id="element-164">
                {/* swap = real Latitude display photo */}
                <img src="https://cdn.magicpatterns.com/uploads/g1maLgE6FVk4XY5re8eFH7/latitude.jpg" alt="Latitude display home by Atrium Homes in Applecross" width={1600} height={1040} loading="lazy" className="object-cover w-full h-full hover:scale-105 transition-editorial duration-800" data-id="element-165" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}